const createDocument = (db, document, path = '') =>
  db
    .post(path, document)
    .then(({ data: { id, rev } }) => ({ id, rev }))

  export default createDocument



// WEBPACK FOOTER //
// ./src/helpers/databases/createDocument.js